import React, { useState, useEffect, Fragment } from 'react';
import SwiperCore, { Autoplay } from 'swiper';
import Button from '@material-ui/core/Button';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/scrollbar/scrollbar.scss';
import './style.css';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import fox from './fox.svg';
import ReactPlayer from 'react-player';
import Swiper from 'swiper';
import Slider from '@material-ui/core/Slider';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import StopIcon from '@material-ui/icons/Stop';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import Snackbar from '@material-ui/core/Snackbar';
import SpeedIcon from '@material-ui/icons/Speed';
import CloseIcon from '@material-ui/icons/Close';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';

const shuffle = (sourceArray) => {
	for (var i = 0; i < sourceArray.length - 1; i++) {
		var j = i + Math.floor(Math.random() * (sourceArray.length - i));

		var temp = sourceArray[j];
		sourceArray[j] = sourceArray[i];
		sourceArray[i] = temp;
	}
	console.log(sourceArray);
	return sourceArray;
};

const data = require('./data.json');
SwiperCore.use([ Autoplay ]);
let swiper;
const App = () => {
	const [ isVisible, setIsVisible ] = useState(true);
	const [ speed, setSpeed ] = useState(1700);
	const [ play, setPlay ] = useState(false);
	useEffect(() => {
		swiper = new Swiper('.swiper-container', {
			spaceBetween: 3,
			slidesPerView: 1,
			// navigation: true,
			pagination: {
				el: '.swiper-pagination',
				type: 'progressbar'
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			autoplay: play,
			speed: 0
		});
	}, []);
	const handleVisible = (e) => {
		setIsVisible(!isVisible);
	};

	const handleAutoplay = () => {
		if (swiper.autoplay.running) {
			swiper.autoplay.stop();
			setMessage('Stop!');
		} else {
			swiper.autoplay.start();
			setMessage('Start!');
		}
		setPlay(swiper.autoplay.running);
		setAlert(true);
	};

	const handleSpeed = (value) => {
		setSpeed(value);
	};

	const [ alert, setAlert ] = React.useState(false);
	const [ message, setMessage ] = useState('');
	const handleAlertClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}

		setAlert(false);
	};

	const [ menu, setMenu ] = useState('day1');
	const [ quiz, setQuiz ] = useState(data[menu]);
	const handleMenu = (key) => {
		setMenu(key);
		setQuiz(data[key]);
	};

	const [ music, setMusic ] = useState(false);

	return (
		<Fragment>
			<ReactPlayer url="videos/bgm.mp3" loop={true} height={0} volume={0.02} playing={music} />
			<div className="card-wrapper">
				<div className="card-container">
					{Object.keys(data).map((key, i) => (
						<Button key={i} onClick={() => handleMenu(key)} color="secondary">
							{key}
						</Button>
					))}
					<img src={fox} className="card-header-image" />
					<div className="card-box">
						<div className="swiper-container">
							<div className="swiper-wrapper">
								{quiz.map((q, i) => (
									<div className="swiper-slide card-content" data-swiper-autoplay={speed}>
										<h2>{q.en}</h2>
										<div className="answer-container">
											{isVisible ? <h1>{q.ja}</h1> : <h1>-</h1>}
										</div>
									</div>
								))}
							</div>
							<div class="swiper-pagination" />
							<div class="swiper-button-next" />
							<div class="swiper-button-prev" />
						</div>

						<IconButton onClick={(e) => handleVisible(e)}>
							{isVisible ? (
								<VisibilityIcon className="icon" className="visibleIcon" />
							) : (
								<VisibilityOffIcon className="visibleIcon" />
							)}
						</IconButton>
						<IconButton>
							{music ? (
								<VolumeUpIcon onClick={() => setMusic(false)} className="volumeIcon" />
							) : (
								<VolumeOffIcon onClick={() => setMusic(true)} className="volumeIcon" />
							)}
						</IconButton>
						<IconButton onClick={(e) => handleAutoplay(e)}>
							{play ? <StopIcon className="playIcon" /> : <PlayArrowIcon className="playIcon" />}
						</IconButton>
						<div className="speed-slider-wrapper">
							<Grid container spacing={2}>
								<Grid item>
									<SpeedIcon className="slider-icon" />
								</Grid>
								<Grid item xs>
									<Slider
										defaultValue={speed}
										getAriaValueText={handleSpeed}
										aria-labelledby="discrete-slider"
										valueLabelDisplay="auto"
										step={200}
										marks
										min={700}
										max={5000}
										className="card-speed-slider"
									/>
								</Grid>
							</Grid>
						</div>
					</div>
				</div>
			</div>
			<Snackbar
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'center'
				}}
				open={alert}
				autoHideDuration={2000}
				onClose={handleAlertClose}
				message={message}
				action={
					<IconButton size="small" aria-label="close" color="inherit" onClick={handleAlertClose}>
						<CloseIcon fontSize="small" />
					</IconButton>
				}
			/>
		</Fragment>
	);
};

export default App;
